import { SidebarMenuItem } from '../../shared/ui/models/private-sidebar.types';

export const SHIPPER_MENU: SidebarMenuItem[] = [
  {
    id: 'home',
    labelKey: 'private.sidebar.home',
    route: '/app/shipper',
    routeExact: true,
    materialIcon: 'home',
    allowedShipperProfiles: ['approver']
  },
  {
    id: 'sara',
    labelKey: 'private.sidebar.sara',
    route: '/app/iaassist',
    materialIcon: 'smart_toy',
    allowedShipperProfiles: ['approver']
  },
  {
    id: 'dashboard',
    labelKey: 'private.sidebar.dashboards',
    route: '/app/shipper/dashboard',
    materialIcon: 'bar_chart',
    allowedShipperProfiles: ['approver']
  },
  {
    id: 'offers',
    labelKey: 'private.sidebar.offers',
    materialIcon: 'handshake',
    allowedShipperProfiles: ['approver'],
    children: [
      {
        id: 'shipper-offers-list',
        labelKey: 'private.sidebar.offers_list',
        route: '/app/shipper/offers',
        routeExact: true,
        materialIcon: 'format_list_bulleted',
        allowedShipperProfiles: ['approver']
      },
      {
        id: 'shipper-offers-spot',
        labelKey: 'private.sidebar.offers_create_spot',
        route: '/app/shipper/offers/spot',
        materialIcon: 'post_add',
        allowedShipperProfiles: ['approver']
      },
      {
        id: 'shipper-offers-contract',
        labelKey: 'private.sidebar.offers_create_contract',
        route: '/app/shipper/offers/contract',
        materialIcon: 'description',
        allowedShipperProfiles: ['approver']
      },
      {
        id: 'shipper-offers-softran',
        labelKey: 'private.sidebar.offers_create_softran',
        route: '/app/shipper/offers/softran',
        materialIcon: 'article',
        allowedShipperProfiles: ['approver']
      },
      {
        id: 'shipper-offers-collection',
        labelKey: 'private.sidebar.offers_create_collection',
        route: '/app/shipper/offers/collection',
        materialIcon: 'local_shipping',
        allowedShipperProfiles: ['approver']
      }
    ]
  },
  {
    id: 'requests',
    labelKey: 'private.sidebar.freight_requests',
    materialIcon: 'assignment',
    allowedShipperProfiles: ['requester', 'order', 'approver'],
    children: [
      {
        id: 'shipper-new-request',
        labelKey: 'private.sidebar.requests_create',
        route: '/app/shipper/requests/new',
        materialIcon: 'add_circle_outline',
        allowedShipperProfiles: ['requester']
      },
      {
        id: 'shipper-my-requests',
        labelKey: 'private.sidebar.requests_list',
        route: '/app/shipper/requests',
        routeExact: true,
        materialIcon: 'search',
        allowedShipperProfiles: ['requester', 'approver']
      },
      {
        id: 'shipper-orders',
        labelKey: 'private.sidebar.orders_list',
        route: '/app/shipper/orders',
        routeExact: true,
        materialIcon: 'receipt_long',
        allowedShipperProfiles: ['order', 'approver'] 
      },
      {
        id: 'shipper-create-order',
        labelKey: 'private.sidebar.orders_create',
        route: '/app/shipper/orders/new',
        routeExact: true,
        materialIcon: 'add_circle_outline',
        allowedShipperProfiles: ['order', 'approver']
      }
    ]
  },
  {
    id: 'carriers',
    labelKey: 'private.sidebar.carriers',
    materialIcon: 'local_shipping',
    allowedShipperProfiles: ['approver'],
    children: [
      {
        id: 'explore-carriers',
        labelKey: 'private.sidebar.carriers_explore',
        route: '/app/shipper/explore-carriers',
        materialIcon: 'explore',
        allowedShipperProfiles: ['approver']
      },
    ]
  },
  {
    id: 'payments',
    labelKey: 'private.sidebar.invoice',
    route: '/app/payments/invoice-extract',
    materialIcon: 'credit_card',
    allowedShipperProfiles: ['approver']
  },
  {
    id: 'news',
    labelKey: 'private.sidebar.news',
    route: '/app/news',
    materialIcon: 'campaign',
    allowedShipperProfiles: ['requester', 'order', 'approver']
  },
  {
    id: 'tutorials',
    labelKey: 'private.sidebar.tutorials',
    route: '/app/shipper/tutorials',
    materialIcon: 'school',
    allowedShipperProfiles: ['approver']
  },
  {
    id: 'settings',
    labelKey: 'private.sidebar.settings',
    materialIcon: 'settings',
    allowedShipperProfiles: ['order', 'approver', 'requester'],
    children: [
      {
        id: 'shipper-settings-group-profile',
        labelKey: 'private.sidebar.settings_group_profile',
        materialIcon: 'person',
        allowedShipperProfiles: ['order', 'approver', 'requester'],
        children: [
          {
            id: 'shipper-settings-profile',
            labelKey: 'private.sidebar.settings_profile',
            route: '/app/configurations-shipper/profile',
            materialIcon: 'manage_accounts',
            allowedShipperProfiles: ['order', 'approver', 'requester']
          }
        ]
      },
      {
        id: 'shipper-settings-group-registrations',
        labelKey: 'private.sidebar.settings_group_registrations',
        materialIcon: 'list_alt',
        children: [
          {
            id: 'shipper-settings-companies',
            labelKey: 'private.sidebar.settings_companies',
            route: '/app/configurations-shipper/companies',
            materialIcon: 'business'
          },
          {
            id: 'shipper-settings-recipients',
            labelKey: 'private.sidebar.settings_recipients',
            route: '/app/configurations-shipper/recipients',
            materialIcon: 'contact_mail'
          },
          {
            id: 'shipper-settings-suppliers',
            labelKey: 'private.sidebar.settings_suppliers',
            route: '/app/configurations-shipper/suppliers',
            materialIcon: 'storefront'
          },
          {
            id: 'shipper-settings-notification-groups',
            labelKey: 'private.sidebar.settings_notification_groups',
            route: '/app/configurations-shipper/notification-groups',
            materialIcon: 'notifications_active'
          },
          {
            id: 'shipper-settings-event-types',
            labelKey: 'private.sidebar.settings_event_types',
            route: '/app/configurations-shipper/event-types',
            materialIcon: 'event'
          },
          {
            id: 'shipper-settings-group-portal',
            labelKey: 'private.sidebar.portal_shipper',
            materialIcon: 'store',
            children: [
              {
                id: 'portal-addresses',
                labelKey: 'private.sidebar.portal_addresses',
                route: '/app/configurations-shipper/addresses',
                materialIcon: 'location_on'
              },
              {
                id: 'portal-items',
                labelKey: 'private.sidebar.portal_items',
                route: '/app/configurations-shipper/items',
                materialIcon: 'inventory_2'
              },
              {
                id: 'portal-item-categories',
                labelKey: 'private.sidebar.portal_item_categories',
                route: '/app/configurations-shipper/item-categories',
                materialIcon: 'category'
              },
              {
                id: 'portal-external-references',
                labelKey: 'private.sidebar.portal_external_references',
                route: '/app/configurations-shipper/external-references',
                materialIcon: 'link'
              }
            ]
          }
        ]
      },
      {
        id: 'shipper-settings-group-users',
        labelKey: 'private.sidebar.settings_group_users',
        materialIcon: 'group',
        children: [
          {
            id: 'shipper-settings-users',
            labelKey: 'private.sidebar.settings_users_registration',
            route: '/app/configurations-shipper/users',
            materialIcon: 'person_add'
          },
          {
            id: 'shipper-settings-teams',
            labelKey: 'private.sidebar.settings_teams',
            route: '/app/configurations-shipper/teams',
            materialIcon: 'groups'
          },
          {
            id: 'shipper-settings-approval-groups',
            labelKey: 'private.sidebar.settings_approval_groups',
            route: '/app/configurations-shipper/approval-groups',
            materialIcon: 'gavel'
          }
        ]
      },
      {
        id: 'shipper-settings-group-system',
        labelKey: 'private.sidebar.settings_group_system',
        materialIcon: 'settings',
        children: [
          {
            id: 'shipper-settings-integrations',
            labelKey: 'private.sidebar.settings_integrations',
            route: '/app/configurations-shipper/integrations',
            materialIcon: 'hub'
          },
          {
            id: 'shipper-settings-notification-agent',
            labelKey: 'private.sidebar.settings_notification_agent',
            route: '/app/configurations-shipper/notification-agent',
            materialIcon: 'mark_email_read'
          },
          {
            id: 'shipper-settings-environment-rules',
            labelKey: 'private.sidebar.settings_environment_rules',
            route: '/app/configurations-shipper/environment-rules',
            materialIcon: 'rule'
          }
        ]
      },
      {
        id: 'shipper-settings-my-plan',
        labelKey: 'private.sidebar.settings_account',
        route: '/app/configurations-shipper/account',
        materialIcon: 'workspace_premium'
      }
    ]
  }
];
